import type { Cage, Transit } from '../index.h'

import { createEvent, sample } from 'effector'
import { profilesFeaturesModel } from '~/features/profiles'
import { keys } from '~/shared/jail'
import { PROFILES } from '~/shared/routes'
import { tainter } from '../tools'

/*
 * ### Profiles cage ###
 */

const init = createEvent<Transit>('init')

// out events
const chooseProfile = createEvent('chooseProfile')

export const profiles = {
  name: 'profiles',
  key: keys.profiles,
  init,
  in: [],
  out: {
    chooseProfile,
  },
  ...tainter(/^\/profiles/, {
    __: PROFILES.CHOOSE,
    shouldCreateProfile: PROFILES.CREATE,
  }),
} satisfies Cage

/*
 * cage logic
 */

sample({
  clock: init,
  source: profilesFeaturesModel.$selectedProfile,
  filter: (_, { reason }) => reason === 'shouldManuallyEditActiveProfile',
  fn: (selectedProfile) => ({ id: selectedProfile!.id }),
  target: profilesFeaturesModel.handleEmptyKidsMultipleTypes,
})

sample({
  clock: profilesFeaturesModel.selectedProfileId,
  target: chooseProfile,
})
